import { render, staticRenderFns } from "./NormalOptionTable.vue?vue&type=template&id=6fb7f8f4&"
import script from "./NormalOptionTable.vue?vue&type=script&lang=ts&"
export * from "./NormalOptionTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports